<template>
    <div>
        <!-- TODO: Style this like the bordered inputs -->
        <div>{{ field.title }}</div>
        <div class="d-flex mb-4 file-gap">
            <div class="thumbnail-wrapper">
                <app-thumbnail
                    :file="file"
                    :can-delete="true"
                    @delete="deleteFile" />
                <v-btn v-if="file" class="edit-button" @click="cropperDialog=true">
                    Edit
                </v-btn>
                <app-file-drop v-if="!file" @input="onInput" />
            </div>
        </div>

        <v-dialog     
            v-model="cropperDialog" 
            width="auto"
            max-width="1100">
            <v-card color="white">
                <v-card-title class="image-card-title">
                    <span>{{ file?.name }}</span>
                </v-card-title>
                <v-card-text>
                    <div class="img-container">
                        <img 
                            v-if="cropperDialog"
                            ref="image"
                            :src="imageUrl"
                            alt=""
                            width="auto"
                            @load="initCropper">                            
                    </div>
                </v-card-text>
                
                <v-card-actions>
                    <app-button
                        color="secondary" 
                        text
                        @click="cropperDialog=false">
                        Close
                    </app-button>
                    <v-spacer />
                    <app-button
                        type="submit"
                        text
                        @click="cropImage">
                        Save
                    </app-button>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import formFieldMixin from "./formFieldMixin";
import { get } from "@/features/schemas/services/schemaApi";
import { imageUrl } from '@/services/imageService';
import Cropper from 'cropperjs/dist/cropper.esm.js';
import 'cropperjs/dist/cropper.css';
import { deleteFile, uploadFile } from "@/services/fileService";

export default {
    types: [ "file" ],
    mixins: [formFieldMixin],
    props: {
        value: {
            type: [String, Number],
            default: null
        }
    },
    data() {
        return {
            file: null,
            cropperDialog : false,
            showCropper : false,
            cropper : null,
            originalFile: null
        }
    },
    computed: {
        imageUrl() {
            return this.file?.id ? imageUrl(this.file.id) : null;
        }
    },
    watch: {
        cropperDialog: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.$nextTick(() => {
                        const image = this.file;
                        if (!image) return;

                        // Destroy existing cropper if it exists
                        if (this.cropper) {
                            this.cropper.destroy();
                        }
                        
                        // Check if image is already loaded
                        if (image.complete) {
                            this.initCropper();
                        } else {
                            // Wait for image to load
                            image.onload = this.initCropper;
                        }
                    });
                } else if (this.cropper) {
                    this.cropper.destroy();
                    this.cropper = null;
                }
            }
        },
        value: {
            immediate: true,
            async handler() {
                if (!this.value) {
                    return;
                }
                await this.getFile();
            }
        }
    },
    beforeDestroy() {
        if (this.cropper) {
            this.cropper.destroy();
        }
    },
    methods: {
        async deleteFile() {
            this.file = null;
            this.$emit("input", null);
        },
        async getFile() {
            this.file = await get("file", this.value);
        },
        onInput(file) {
            this.$emit("input", file.id);
        },
        initCropper() {
            const image = this.$refs.image;
            if (!this.file) return;

            // Destroy existing cropper if it exists
            if (this.cropper) {
                this.cropper.destroy();
            }

            this.cropper = new Cropper(image, {
                aspectRatio          : 1,
                viewMode             : 1,
                responsive           : true,
                restore              : false,
                minContainerWidth    : 400,
                minContainerHeight   : 400,
                quality              : 1,
                imageSmoothingEnabled: true,
                imageSmoothingQuality: 'high',
            });
        },
        cropImage() {
            if (!this.cropper) return;

            this.cropper.getCroppedCanvas().toBlob(
                async (blob) => {
                    this.originalFile = this.file;
                    const croppedFile = new File([blob], this.originalFile.name, {
                        type: this.originalFile.type
                    });
                    const uploadedfile = await uploadFile(croppedFile);
                    this.file = uploadedfile;
                    await deleteFile(this.originalFile.id);
                    this.originalFile = this.file;
                    this.$emit("input", uploadedfile.id);
                    this.cropperDialog = false;
                },
            );
        },
    },
}
</script>
<style scoped>
.d-flex {
    display: flex;
}

.file-gap {
    gap          : 10px;
    display      : flex;
    flex-wrap    : wrap;
    margin-bottom: 16px;
}

.align-center {
    align-items: center; 
}

.thumbnail-wrapper {
    display: flex;
    flex-direction: column; 
    align-items: center; 
    margin-right: 16px; 
}

.edit-button {
    margin-top: 8px; 
}
</style>
